const messageListTypes = {
  JOURNAL_ENTRY_CLIENT_COMMENT: 'JOURNAL_ENTRY_CLIENT_COMMENT',
  JOURNAL_ENTRY_INTERNAL_NOTE: 'JOURNAL_ENTRY_INTERNAL_NOTE',
  LEDGER_ACCOUNT_INTERNAL_NOTE: 'LEDGER_ACCOUNT_INTERNAL_NOTE',
};

export default messageListTypes;
